import { AxiosInstance } from "../utils/axios-helper/axios-helper";
import { API_END_POINT } from "../utils/constants/api-end-points";
import {version} from '../config'

//get all the details of home page
export const getFaqDetails = async (data) => {
  return await AxiosInstance.get(`${version}${API_END_POINT.faqDetails}?languageId=${data.languageId}`);
};